import React from "react";
import i18n from "../../../i18n/i18n";
import PriceForm from "../priceForm/priceForm";
import "./addPrice.scss";

export default class AddPrice extends React.Component {
    render() {
        return (
            <div className="add-price content">
                <div className="header">
                    {i18n.t("priceList.addPrice.header")}
                </div>
                <div>
                    <PriceForm isUpdate={false}/>
                </div>
            </div>
        );
    }
}